module.exports = __webpack_public_path__ + "img/IMG-20200705-WA0021.0d39e68c.jpg";